import tmhRequest from '@/config/tmhRequest'

export default {

    searchListScheduling: function (data) {
        return tmhRequest({
            url: '/employee/tmh/scheduling/searchlistscheduling',
            method: 'post',
            params: data,
        })
    },

    addScheduling: function (data) {
        return tmhRequest({
            url: '/employee/tmh/scheduling/addscheduling',
            method: 'post',
            data: data,
        })
    },

    adjustScheduling: function (data) {
        return tmhRequest({
            url: '/employee/tmh/scheduling/adjustscheduling',
            method: 'post',
            params: data,
        })
    },
} 


// WEBPACK FOOTER //
// ./src/api/tmh/employee/scheduling.js